import React, {useEffect} from "react";
import AutoCatalogSelector from "./AutoCatalogSelector";
import {observer} from "mobx-react-lite";
import {
    Button,
    Grid,
    Header, HeaderSubheader,
    Icon,
    Label,
    LabelGroup,
    List,
    Placeholder,
    Popup
} from "semantic-ui-react";
import DeleteButton from "../../Pages/Shared/DeleteButton";
import AutoCatalogStore from "./AutoCatalogStore";

function AutoCatalog(props: { store: AutoCatalogStore }) {
    const {store} = props;
    useEffect(() => {
        return function cleanup() {
            store.cleanup();
        }
    }, []);
    if (store.loading) {
        return <Grid columns={1}>
            <Grid.Column width={8}>
                <List>
                    <Placeholder fluid>
                        <Placeholder.Line length='full'/>
                        <Placeholder.Line length='very long'/>
                        <Placeholder.Line length='full'/>
                        <Placeholder.Line length='very long'/>
                        <Placeholder.Line length='long'/>
                        <Placeholder.Line length='full'/>
                        <Placeholder.Line length='very long'/>
                        <Placeholder.Line length='long'/>
                        <Placeholder.Line length='full'/>
                    </Placeholder>
                </List>
            </Grid.Column>
        </Grid>
    }
    return <Grid columns={2}>
        {store.currentSelector && <Grid.Column computer={9} largeScreen={7} tablet={8} mobile={8} widescreen={5}>
            <Grid.Row style={{paddingBottom: '10px'}}>
                <Header>Укажите параметры авто</Header>
            </Grid.Row>
            <Grid.Row>
                <AutoCatalogSelector store={store.currentSelector}/>
            </Grid.Row>
        </Grid.Column>}
        <Grid.Column computer={7} largeScreen={7} tablet={8} mobile={8} widescreen={4}>
            <Grid.Row style={{paddingBottom: '10px'}}>
                <Header>Совместимые авто
                    <HeaderSubheader>
                        <a target={'_blank'} href={'https://wiki.unitxml.ru/avito/start#autocatalog'}>Документация</a>
                    </HeaderSubheader>
                </Header>
            </Grid.Row>
            <Grid.Row style={{paddingBottom: '10px'}}>
                {store.hasApplied
                    ? <List divided selection>
                        {store.selectors.filter(s => s.applied).map(s =>
                            <List.Item active={store.currentSelector === s} key={s.id}
                                       onClick={() => store.select(s)}>
                                <DeleteButton onDelete={() => store.delete(s)}/>
                                <Icon size='large' name='car'/>
                                <List.Content>
                                    <List.Header>
                                        {s.appliedCar!.make.name + " " + s.appliedCar!.model.name}
                                        {s.hasChanges
                                            && <Popup trigger={<Icon style={{marginLeft: '5px'}} name={'warning circle'}
                                                                     color={'red'}/>} content={'Есть изменения'}/>}
                                    </List.Header>
                                    {s.appliedCar!.generation.name}
                                    {s.appliedCar!.modification &&
                                        <LabelGroup style={{paddingTop: '5px'}}>
                                            <Label color='purple' horizontal>
                                                {s.appliedCar!.modification.name}
                                            </Label>
                                        </LabelGroup>}
                                    {(s.appliedCar!.complectation || s.appliedCar!.body) &&
                                        <LabelGroup style={{paddingTop: '5px'}}>
                                            {s.appliedCar!.complectation &&
                                                <Label color='green' horizontal>
                                                    {s.appliedCar!.complectation.name}
                                                </Label>}
                                            {s.appliedCar!.body &&
                                                <>
                                                    <Label color='blue' horizontal>
                                                        {s.appliedCar!.body.type}
                                                    </Label>
                                                    <Popup trigger={<Label color='teal' horizontal>
                                                        {s.appliedCar!.body.doors}
                                                    </Label>} content={'Количество дверей'}/>
                                                </>
                                            }
                                        </LabelGroup>}
                                </List.Content>
                            </List.Item>
                        )}
                    </List>
                    : <>Список пуст</>}
            </Grid.Row>
            <Grid.Row>
                {store.canAdd &&
                    <Button primary={true} onClick={() => store.tryAdd()}><Icon name='add'/>Добавить</Button>}
                {store.canSave &&
                    <Button loading={store.saving} primary={true} onClick={() => store.save()} floated={'right'}>
                        <Icon name='save'/>Сохранить</Button>}
                {store.savedCationVisible && <Label color={'teal'}>Сохранено!</Label>}
            </Grid.Row>
        </Grid.Column>
    </Grid>
}

export default observer(AutoCatalog);